import { axios as $http } from 'cm'
import { getRunTime } from 'src/public-resource/libs/utils/index.js'
import { getPlatform } from 'src/frontend-lib/tools/getPlatform.js'
import Bridge from 'src/frontend-lib/lib/Bridge.js'

// 判断环境
let HOST = getRunTime('//m.xinli001.com/')
const APIS = {
  publish: `${HOST}psychic-coach/create-pay-order`
}

const $platform = getPlatform()
let myBridge = new Bridge()
const BASE_TEXT = `公开的内容每次被其它用户旁听1次，收益与心探教练平分。收益以鲸币的形式获得。`
const PUBLIC_TEXT = `已开启支持旁听，` + BASE_TEXT

export default class PageNewTwo {
  constructor(coachInfo) {
    this.pageEl = document.querySelector('.page_new_2')
    this.coachInfo = coachInfo
    this.customPrice = coachInfo.self_price.split(',')
    this.isPublic = 1 // 是否公开，支持旁听
    this.price = undefined
    // 手动输入价格相关的变量--start
    this.lockInput = false
    this.maxVal = 500
    this.minVal = +this.customPrice.shift()
    // 手动输入价格相关的变量--end
    this.publishing = false

    this.renderHTML()
    setTimeout(() => {
      this.switchEl = this.pageEl.querySelector('.ff-switch')
      this.handleSwitch()
      this.listenRewardButtons()
      this.listenInput()
      this.listenPublishButton()
    }, 40) // 等html先渲染完
  }

  // 供PageNewOne调用
  setCoachInfo(item) {
    this.coachInfo = item
    this.updateCoachName()
  }

  updateCoachName() {
    const nameEl = this.pageEl.querySelector('.ff-title .ff-name')
    nameEl.innerHTML = this.coachInfo.nickname
  }

  renderHTML() {
    const html = `
      <div class="ff-title">
        付费问答——向心探教练<span class="ff-name">${this.coachInfo.nickname}</span>的提问
      </div>
      <div class="ff-section-title">提问选项</div>
      <div class="ff-section-one">
        <div class="section-one-top">
          <p class="ff-tip">是否公开，支持旁听</p>
          <div class="ff-switch">
            <div class="ff-swtch-ball"></div>
          </div>
        </div>
        <div class="section-one-bottom"></div>
      </div>
      <div class="ff-section-title">问题赏金</div>
      <div class="ff-section-two">
        <ul class="ff-item-list">
          <li class="ff-item btn"><span class="ff-price">${this.customPrice[0]}元</span></li>
          <li class="ff-item btn"><span class="ff-price">${this.customPrice[1]}元</span></li>
          <li class="ff-item btn"><span class="ff-price">${this.customPrice[2]}元</span></li>
          <li class="ff-item form">
            <input class="ff-input" type="number" max="500" min="${this.minVal}" placeholder="自定义输入${this.minVal}~500元">
          </li>
        </ul>
      </div>
      <div class="ff-publish">去发布</div>
    `
    const wrapper = this.pageEl.querySelector('.ff-new-inner')
    wrapper.insertAdjacentHTML('beforeend', html)
  }

  handleSwitch() {
    this.handleSwitchStatus()
    this.switchEl.addEventListener('click', () => {
      this.isPublic = this.isPublic === 1 ? 0 : 1
      this.handleSwitchStatus()
    })
  }

  handleSwitchStatus() {
    if (this.isPublic === 1) {
      this.switchEl.classList.add('active')
      this.pageEl.querySelector('.section-one-bottom').innerHTML = PUBLIC_TEXT
    } else {
      this.switchEl.classList.remove('active')
      this.pageEl.querySelector('.section-one-bottom').innerHTML = BASE_TEXT
    }
  }

  listenRewardButtons() {
    const itemListEl = this.pageEl.querySelectorAll('.ff-item.btn')
    itemListEl.forEach(itemEl => {
      itemEl.addEventListener('click', e => {
        const priceEl = itemEl.querySelector('.ff-price')
        this.price = Number.parseInt(priceEl.textContent.trim())
        // 高亮提示
        itemListEl.forEach(v => v.classList.remove('active'))
        itemEl.classList.add('active')
      })
    })
  }

  listenInput() {
    const inputEl = this.pageEl.querySelector('.ff-input')

    inputEl.addEventListener('compositionstart', () => {
      this.lockInput = true
    })

    inputEl.addEventListener('compositionend', () => {
      this.lockInput = false
      // 中文输入结束后，清除"数字"和"."以外的字符
      inputEl.value = inputEl.value.replace(/[^\d\.]/g, '')
    })

    inputEl.addEventListener('input', e => {
      // 不处理中文输入
      if (this.lockInput) return
      const target = e.target
      // 清除"数字"以外的字符
      target.value = target.value.replace(/[^\d]/g, '')

      // 有输入，需限制数值范围。
      if (target.value.length) {
        if (target.value > this.maxVal) {
          target.value = this.maxVal
        } else if (target.value < this.minVal) {
          target.value = this.minVal
        }
        // 记录价格
        this.price = Number(target.value)
        // 悬赏按钮移除active
        const itemListEl = this.pageEl.querySelectorAll('.ff-item.btn')
        itemListEl.forEach(v => v.classList.remove('active'))
      } else {
        // 没输入则重置价格
        this.price = undefined
      }
    })

    // fix：IOS，软键盘消失后，页面底部留白
    inputEl.addEventListener('blur', () => {
      if ($platform.isiOS) {
        setTimeout(() => {
          const t =
            document.documentElement.scrollTop || document.body.scrollTop || 0
          window.scrollTo(0, Math.max(t - 1, 0))
        }, 200)
      }
    })
  }

  listenPublishButton() {
    const publishEl = this.pageEl.querySelector('.ff-publish')
    publishEl.addEventListener('click', () => {
      // 价格必填
      if (this.price === undefined) {
        return window.toast('请先设置悬赏金额')
      }
      this.publish()
    })
  }

  publish() {
    if (this.publishing) return // 避免重复点击
    $('.loadingDiv').show()
    window.yxl.stat.send({
      name: '答疑馆',
      properties: {
        行为: '点击',
        页面: '心探教练提问流程',
        对象: '去发布'
      }
    })
    this.publishing = true
    const params = {
      user_id: this.coachInfo.user_id, // 心探教练ID
      content: document.querySelector('#ask_content').value.trim(), // 提问内容
      title: document.querySelector('#ask_title').value.trim(), // 提问标题
      is_niming: window.askActiveNum(), // 是否匿名
      is_public: this.isPublic,
      price: this.price * 100, // 金额，单位分
      tags: window.secondTag().join(','), // 二级标签合集
      tag_id: window.firstTag() // 一级标签id
    }
    console.log(params)
    $http
      .post(APIS.publish, params)
      .then(async res => {
        const { code, data } = res.data
        if (code === 0) {
          // 发布成功后，跳到订单页
          let url = `${location.protocol}${getRunTime(
            `//static.xinli001.com/`
          )}msite/index.html#/heart-search/paid-qa-order/${data.question_id}`
          // 跳转前移除离开提示
          window.removeUnloadHandler()

          // await window.sleep(40)
          $('.loadingDiv').hide()
          window.toast('发布成功, 正在跳转支付...', 2000, () => {
            if ($platform.isYixinliApp || $platform.isZiXunApp) {
              myBridge.call('openWebView', {
                url: url,
                hideNavigationBar: 1
              })
            } else {
              window.location.href = url
            }
          })
        }
      })
      .catch(err => {
        console.log(err)
      })
      .finally(() => {
        this.publishing = false
      })
  }
}



// WEBPACK FOOTER //
// ./src/pages/ask/questionProcess/js/PageNewTwo.js